/* eslint-disable react/jsx-no-duplicate-props */
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../assets/Icons";
import RemitterAccountViewAll from "../../../../containers/Accounts/RemitterAccount/RemitterAccountViewAll";
import { GlobalConfiguration } from "../../../../utils/configurationProvider";
import globalText from "../../../../utils/globalText";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../_utils/CommonSmallPopup";

const RemitAccountViewAllPopup = (props) => {
  const navigate = useNavigate();
  const [alertPopup, setAlertPopup] = useState(false);
  const [pendingNavTarget, setPendingNavTarget] = useState(null);
  const [selectedCardIds, setSelectedCardIds] = useState(
    Array.isArray(props?.id) ? props?.id : [props?.id],
  );

  const handleCardNavigate = (targetPath) => {
    setPendingNavTarget(targetPath);
    setAlertPopup(true);
  };

  const handleLeaveConfirm = () => {
    setAlertPopup(false);
    props?.closePopup(false);
    if (pendingNavTarget) {
      navigate(pendingNavTarget);
    }
    setPendingNavTarget(null);
  };

  const handleAlertCancel = () => {
    setAlertPopup(false);
    setPendingNavTarget(null);
  };

  return (
    <>
      {alertPopup && (
        <div
          className="fixed z-z-index-max flex items-center justify-center top-left-base left-left-base w-width-full h-height-full bg-PopUp-BackDrop bg-opacity-dark-opacity"
          onClick={(e) => e.stopPropagation()}
        >
          <SmallPopup
            headerTitle={globalText?.LEAVE_PAGE_WARNING_HEADER}
            headerFontWeight="semibold"
            headerFontColor="emphasis"
            textSize="font-lg"
            subtext={globalText?.LEAVING_PAGE_WILL_EXIT_FROM_CURRENT_FLOW}
            btnOneText={globalText?.STAY}
            btnOneHandleFunction={handleAlertCancel}
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneOutLineColor="var(--text-primary)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneIsDisabled={false}
            btnOneHoverOption="white"
            btnTwoText={globalText?.LEAVE}
            btnTwoHandleFunction={handleLeaveConfirm}
            btnTwoEnabledBgColor="var(--negative-act)"
            btnTwoEnabledTextColor="var(--text-primary)"
            btnTwoIsDisabled={false}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoIsLoaderNeeded={true}
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <LargePopupRedirect
        headerTitle={props?.headerTitle}
        headersubtext={props?.headersubtext}
        closeiconenabledBgColor="var(--primary-nav)"
        closeiconisLoading={false}
        closeiconhandleFunction={() => props?.closePopup(false)}
        closeicon={ICONS?.CLOSE}
        closeiconhoverOption="white"
        closeiconbtnType={"button"}
        smallpopupsubtext="Leaving this page will exit from the current flow."
        closeiconisDisabled={false}
        closeicondisabledBgColor={""}
        closeiconbuttonRef={null}
        closeicontitle={"Close"}
        btnType={"button"}
        fullWidthRequired={true}
        isbottomSectionneed={props?.showModalPopup}
        bottomHeaderTextNeed={true}
        bottomHeaderText={props?.bottomHeaderText}
        confirmbtnrequired={props?.showModalPopup}
        btnText={props?.btnText}
        isDisabled={
          selectedCardIds?.length === GlobalConfiguration.lengthCheckZero
            ? true
            : props?.createDisabled
        }
        inActiveVariantNeeded
        isLoaderNeeded={true}
        isLoading={props?.createDisabled}
        enabledBgColor={
          selectedCardIds?.length === GlobalConfiguration.lengthCheckZero
            ? "var(--text-disabled)"
            : "var(--positive-act)"
        }
        enabledTextColor={"var(--text-primary)"}
        disabledBgColor={
          props?.createDisabled ? "var(--positive-act)" : "var(--text-disabled)"
        }
        disabledTextColor={"var(--text-primary)"}
        outLineColor={""}
        hoverOption={"dark"}
        handleFunction={() => {
          if (selectedCardIds?.length > GlobalConfiguration.lengthCheckZero) {
            props?.handleConfirmBtnClick(selectedCardIds);
          }
        }}
        isfullViewrequired={props?.isfullViewrequired}
        fullviewbtnText="Register a new account"
        redirectHeader="Register a new account"
        smallPopupHeader={props?.smallPopupHeader}
        fullviewhandleFunction={() => {
          navigate("/remitter_account_dashboard/create_remitter_account");
        }}
        redirectIcon={ICONS?.ADD_BUTTON_WHITE}
      >
        <RemitterAccountViewAll
          id={props?.id}
          remName={props?.remName}
          remLabel={props.remLabel}
          type={props?.type}
          propType={props?.propType}
          onCardNavigate={
            props?.onCardNavigate ? handleCardNavigate : undefined
          }
          cardType={props?.cardType}
          selectedCardIds={selectedCardIds}
          setSelectedCardIds={setSelectedCardIds}
        />
      </LargePopupRedirect>
    </>
  );
};

export default RemitAccountViewAllPopup;
